<template>
    <div class="top-nav-search">
        <div class="row align-items-center justify-content-end mx-0">
            <div class="col-md-8 p-0 flex-1">
                <div class="flex-fill">
                    <div class="search-card-body">
                        <div class="statistic-header py-1 mb-0 justify-content-end flex-1">
                            <div class="col-12">
                                <div class="form-wrap icon-form mb-0 position-relative" ref="dropdownWrapper">
                                    <span class="form-icon">
                                        <i class="ti ti-search"></i>
                                    </span>
                                    <input type="text" class="form-control" placeholder="Search" v-model="searchQuery"
                                        @focus="showModules = true" @blur="showModules = true"
                                        @input="showModules = true" />

                                    <!-- Suggestions Dropdown -->
                                    <div v-if="showModules"
                                        class="suggestions-list border bg-white position-absolute w-100 mt-1 z-3 shadow-sm rounded">
                                        <!-- Module Tags -->
                                        <div class="px-3 py-2 border-bottom d-flex flex-wrap gap-2">
                                            <span v-for="(label, module) in moduleMap" :key="module" class="badge"
                                                :class="{
                                                    'bg-primary text-white': selectedModule === module,
                                                    'moduleColor text-white': selectedModule !== module
                                                }" @click="selectModule(module)">
                                                {{ module }}
                                            </span>
                                        </div>

                                        <!-- Section Title -->
                                        <div class="p-3 text-muted small fw-bold text-capitalize">
                                            {{ selectedModule === 'all' || !selectedModule ? 'Organisations' :
                                                selectedModule }}
                                        </div>

                                        <!-- Suggestions List -->
                                        <div v-if="suggestions.length" @scroll="onScroll" ref="searchResultContainer"
                                            class="searchResult">
                                            <div v-for="(item, index) in suggestions" :key="'org-' + index"
                                                class="px-3 py-2 border-bottom">
                                                <div class="d-flex justify-content-between align-items-center">
                                                    <div
                                                        v-if="selectedModule === 'organisations' || selectedModule === 'all'">
                                                        <div class="fw-semibold" v-if="item.organization_id">
                                                            <template
                                                                v-if="route.query.org_Id !== item.organization_id">
                                                                <router-link
                                                                    :to="{ path: '/crm/create-organisation', query: { org_Id: item.organization_id } }">{{
                                                                        item.organization_name }} <small class="ms-4">{{
                                                                        item.responsible_name
                                                                    }}</small></router-link>
                                                            </template>
                                                            <template v-else>
                                                                <span title="Already in same organisation">{{
                                                                    item.organization_name }}</span>
                                                                <small title="Already in same organisation"
                                                                    class="ms-4">({{
                                                                        item.responsible_name }})</small>
                                                            </template>
                                                        </div>
                                                        <div class="fw-semibold" v-if="!item.organization_id">

                                                            <span else class="badge bg-light text-muted border ">
                                                                {{ item.organization_name }} <small class="ms-4">NO
                                                                    ACCESS</small></span>
                                                        </div>


                                                    </div>

                                                    <div v-if="selectedModule === 'opportunities' || selectedModule === 'comment'">
                                                        <div class="fw-semibold">
                                                            <template v-if="route.params.id !== item.id">
                                                                <router-link :to="{
                                                                    path: `/crm/meter-opportunities-edit/${item.id}`,

                                                                }">
                                                                    {{ item.organization_name }}
                                                                    <small class="ms-4">opportunity({{
                                                                        item.opportunity_number }})</small>
                                                                </router-link>
                                                            </template>
                                                            <template v-else title="Already in same meter opportunity">
                                                                <span title="Already in same meter opportunity">{{
                                                                    item.organization_name }}</span>
                                                                <small title="Already in same meter opportunity"
                                                                    class="ms-4">opportunity({{
                                                                        item.opportunity_number }})</small>
                                                            </template>
                                                        </div>
                                                    </div>



                                                    <div v-if="selectedModule === 'person'">
                                                        <div class="fw-semibold">
                                                            <router-link
                                                                :to="{ path: '/crm/create-organisation', query: { org_Id: item.organization_id } }">
                                                                {{ item.first_name }} {{ item.last_name }} <small
                                                                    class="ms-4"> {{
                                                                        item.organization_name }}</small></router-link>
                                                        </div>

                                                    </div>

                                                    <div v-if="selectedModule === 'contracts'">
                                                        <div class="fw-semibold">
                                                            <template v-if="route.params.id !== item.id">
                                                                <router-link :to="{
                                                                    path: `/crm/edit-contract/${item.id}`
                                                                }">
                                                                    {{ item.organization_name }} <small
                                                                        class="ms-4">contract({{
                                                                            item.contract_number
                                                                        }}) </small>
                                                                </router-link>
                                                            </template>
                                                            <template v-else>
                                                                <span title="Already in same contract">{{
                                                                    item.organization_name }}</span>
                                                                <small title="Already in same contract"
                                                                    class="ms-4">contract({{
                                                                        item.contract_number }})</small>
                                                            </template>
                                                        </div>

                                                    </div>
                                                    <!-- <span class="badge bg-light text-muted border">NO ACCESS</span> -->
                                                </div>
                                            </div>
                                        </div>
                                        <div class="text-center mb-2" v-else>
                                            <span>No Data Found</span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <!-- <div class="col-md-2 px-2"></div> -->
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script setup>
import { nextTick, onMounted, onUnmounted, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useStore } from 'vuex'

const store = useStore()
const route = useRoute()

const searchQuery = ref('')
const suggestions = ref([])
const showModules = ref(false)
const selectedModule = ref('organisations')

const moduleMap = ref({})
const dropdownWrapper = ref(null)
const isFetching = ref(false);
const curr_page = ref(1)
const total = ref(null)
const searchResultContainer = ref(null);
const hasMore = ref(true);

// Handle module selection
const selectModule = (module) => {
    selectedModule.value = module;
    curr_page.value = 1;
    total.value = null;
    hasMore.value = true;
    if (searchQuery.value) {
        getSearchResults();
    } else {
        suggestions.value = [];
    }
}

// Perform search
// const getSearchResults = async (page) => {
//     try {
//         if (isFetching.value) return;
//         isFetching.value = true;
//         const payload = {
//             search: searchQuery.value,
//             module: moduleMap.value[selectedModule.value],
//             page: page || current_page
//         }
//         let count = suggestions.value.length;
//         if (count >= 10 && suggestions.value.total > count) {
//             const current_page = Math.ceil(count / 10) + 1;
//             const data = await store.dispatch('dashboard/globalSearch', payload)
//             suggestions.value = data.organisations || data[selectedModule.value] || []
//             return;
//         }
//     } catch (error) {
//         console.error('Search error:', error)
//         suggestions.value = []
//     }
//     finally {
//         isFetching.value = false;
//     }
// }

const appendDynamicData = (existingData, dynamicData) => {
    const combinedOutput = existingData.slice(); // Clone the existing output array
    dynamicData.forEach((item) => {
        combinedOutput.push(item);
    });
    suggestions.value = combinedOutput;
    return { data: combinedOutput };
};

const getSearchResults = async () => {
    try {
        if (isFetching.value || !hasMore.value) return;

        isFetching.value = true;

        const resData = await store.dispatch('dashboard/globalSearch', {
            page: curr_page.value,
            search: searchQuery.value,
            module: moduleMap.value[selectedModule.value],
        });

        const response =
            resData?.organisations ||
            resData?.[selectedModule.value] ||
            (selectedModule.value === 'comment' ? resData?.opportunities : null);

        const data = response?.data || [];

        if (curr_page.value === 1) {
            suggestions.value = data;
        } else {
            appendDynamicData(suggestions.value, data);
        }

        // Check if more pages exist
        hasMore.value = !!response?.next_page_url;

        // Increment page only if next page exists
        if (hasMore.value) {
            curr_page.value++;
        }

    } catch (error) {
        console.error("Error fetching search data:", error);
    } finally {
        isFetching.value = false;
    }
};

const onScroll = async (event) => {
    const element = event.target;
    if (element.scrollTop + element.clientHeight >= element.scrollHeight - 3 && !isFetching.value && hasMore.value) {
        if (searchQuery.value) {
            getSearchResults()
        }
    }
};

const handleClickOutside = (event) => {
    if (dropdownWrapper.value && !dropdownWrapper.value.contains(event.target)) {
        showModules.value = false
    }
}

onMounted(async () => {
    document.addEventListener('click', handleClickOutside)
    const modulesData = await store.getters['dashboard/getModulesData']
    if (modulesData.length === 0) {
        const data = await store.dispatch('dashboard/globalSearchModule')
        moduleMap.value = { ...data, comment: 'opp-comment' }
    } else {
        moduleMap.value = { ...modulesData, comment: 'opp-comment' }
    }

})
// Debounce timer
let debounceTimeout = null;

// Watch search input
watch(searchQuery, (newQuery) => {
    // Clear any pending debounce
    clearTimeout(debounceTimeout);

    // If input is empty, reset suggestions and exit
    if (!newQuery || newQuery.trim() === '') {
        suggestions.value = [];
        curr_page.value = 1;
        total.value = null;
        hasMore.value = true;
        return;
    }

    // Only trigger search after user stops typing for 500ms
    debounceTimeout = setTimeout(async () => {
        curr_page.value = 1;  // reset page only when search triggers
        total.value = null;    // reset total only when search triggers
        hasMore.value = true;
        await getSearchResults();
    }, 1000);
});

// Clear timeout on unmount
onUnmounted(() => {
    clearTimeout(debounceTimeout);
    document.removeEventListener('click', handleClickOutside);
});


// Watch for changes in the selected module
watch(selectedModule, async () => {
    await nextTick(); // wait for DOM to update
    if (searchResultContainer.value) {
        searchResultContainer.value.scrollTop = 0; // reset scroll to top
    }
});
</script>

<style scoped>
.suggestions-list {
    max-height: 450px;
    /* overflow-y: auto; */
    border-radius: 0.5rem;
    box-shadow: 0 4px 8px rgba(0, 0, 0, 0.2) !important;
    overflow: hidden;
}

.badge {
    font-size: 0.85rem;
    cursor: pointer;
}

.moduleColor {
    background-color: grey;
}

.searchResult {
    max-height: 35vh;
    overflow-y: auto;
}
</style>